import { DashboardTile } from "../components/DashboardTile";
import {
  UserFeatureNotification,
  useRegisterNotifyMeForFeatureMutation,
} from "@common/utils/graphql";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { useUserStore } from "@domains/auth/utils/useUserStore";

export const GetHypercardTile = () => {
  const { toast } = useToast();
  const [registerNotifyMeForFeature] = useRegisterNotifyMeForFeatureMutation();

  const handleNotifyMe = async () => {
    const { data } = await registerNotifyMeForFeature({
      variables: {
        feature: UserFeatureNotification.HypercardLaunch,
      },
    });

    if (
      data?.registerNotifyMeForFeature.__typename ===
      "MutationRegisterNotifyMeForFeatureSuccess"
    ) {
      toast({
        title: "You will be notified when the Hypercard is launched",
      });
    }
  };

  const cardImageUrl = useUserStore((state) => state.homePageCardImageUrl);

  return (
    <DashboardTile
      className="relative flex h-full items-center bg-black bg-none md:bg-contain md:bg-right-bottom md:bg-no-repeat"
      style={{
        backgroundImage: `url(${cardImageUrl})`,
      }}
    >
      <div className="max-w-[350px]">
        <div className="mb-3 text-pretty font-serif text-3xl">
          Metal card specially crafted for you
        </div>
        <div className="text-sm text-slate">
          Make an impression with a metal card
        </div>
        <Button onClick={handleNotifyMe} className="mt-8 w-[200px]">
          Get Notified
        </Button>
      </div>
    </DashboardTile>
  );
};
